import request from './httpService';

const AUDIT_ENDPOINT = '/audit';

/**
 * Get audit logs with filtering and pagination
 * @param {Object} params - Filter parameters (entityType, entityId, userId, action, locationId, startDate, endDate, searchTerm, page, pageSize)
 */
const getAuditLogs = (params) => {
    return request({
        method: 'GET',
        url: `${AUDIT_ENDPOINT}/logs`,
        params: params
    });
};

/**
 * Get audit trail for a specific entity
 * @param {String} entityType - Entity type (e.g., 'Invoice', 'Customer', 'Payment')
 * @param {String} entityId - Entity ID
 */
const getEntityAuditTrail = (entityType, entityId) => {
    return request({
        method: 'GET',
        url: `${AUDIT_ENDPOINT}/entity/${entityType}/${entityId}`
    });
};

/**
 * Get PHI access logs for a patient
 * @param {String} patientId - Patient/Customer ID
 * @param {Object} params - Filter parameters (startDate, endDate, limit)
 */
const getPatientPHIAccessLogs = (patientId, params = {}) => {
    return request({
        method: 'GET',
        url: `${AUDIT_ENDPOINT}/phi/patient/${patientId}`,
        params: params
    });
};

/**
 * Get compliance report
 * @param {Object} params - Report parameters (startDate, endDate, entityType, userId)
 */
const getComplianceReport = (params) => {
    return request({
        method: 'GET',
        url: `${AUDIT_ENDPOINT}/report/compliance`,
        params: params
    });
};

/**
 * Get audit summary statistics
 * @param {Object} params - Summary parameters (startDate, endDate)
 */
const getAuditSummary = (params) => {
    return request({
        method: 'GET',
        url: `${AUDIT_ENDPOINT}/summary`,
        params: params
    });
};

export const AuditService = {
    getAuditLogs,
    getEntityAuditTrail,
    getPatientPHIAccessLogs,
    getComplianceReport,
    getAuditSummary
};

export default AuditService;
